module.exports = __webpack_public_path__ + "static/media/table-unsorting.870959e8.svg";